import { render, staticRenderFns } from "./AccessibilityFormComponent.vue?vue&type=template&id=2fd7a8b4&xmlns=true&"
import script from "./AccessibilityFormComponent.vue?vue&type=script&lang=js&"
export * from "./AccessibilityFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fd7a8b4')) {
      api.createRecord('2fd7a8b4', component.options)
    } else {
      api.reload('2fd7a8b4', component.options)
    }
    module.hot.accept("./AccessibilityFormComponent.vue?vue&type=template&id=2fd7a8b4&xmlns=true&", function () {
      api.rerender('2fd7a8b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-event/basic-data/forms/accessibility-form/AccessibilityFormComponent.vue"
export default component.exports